import React, { useState, useEffect } from 'react';
import { CheckboxGroup as CheckboxGroupPoi } from '@Sage/hoi-poi-ui';

function CheckboxGroup({ inputs, ...props }) {
    const [data, setData] = useState([]);
    useEffect(() => {
        const options = inputs.map((input) => ({
            label: input.label,
            value: input.name,
            hint: input.info,
        }));
        const isReadOnly = inputs.map((input) => input.isReadOnly);
        setData({ options, isReadOnly });
    }, [inputs]);

    return (
        <CheckboxGroupPoi
            options={data.options}
            {...props}
            isReadOnly={data.isReadOnly}
            isFullWidth={false}
            color="actionMinor"
        />
    );
}

export default CheckboxGroup;
